import { createStructuredSelector } from 'reselect';

import {
  selectAdvisors,
  mapData,
} from '../../../../../selectors/globalSelectors';
import { fetchGAWState } from './LoadingPageSelectors';

/** Confirmation Page data maping */
export const confirmationMap = (state) => {
  const { confirmationData } = fetchGAWState(state);
  return confirmationData;
};

export const selectAccountID = (state) => {
  const { accountData } = fetchGAWState(state);
  if (accountData && accountData.data && accountData.data.accountId) {
    return accountData.data.accountId;
  }
  return '';
};

export const selectGrantPurpose = (state) => {
  const { purpose } = confirmationMap(state);
  if (purpose) {
    return purpose;
  }
  return {};
};

export const selectGrantRecognitions = (state) => {
  const { grantRecognition } = confirmationMap(state);
  if (grantRecognition) {
    return grantRecognition;
  }
  return {};
};

export const selectGranteeOrg = (state) => {
  const { granteeOrg } = confirmationMap(state);
  if (granteeOrg) {
    return granteeOrg;
  }
  return {};
};

export const selectGrantAgreementId = (state) => {
  const { grantAgreementId } = confirmationMap(state);
  if (grantAgreementId) {
    return grantAgreementId;
  }
  return '';
};

export const selectConfirmationPools = (state) => {
  const { confirmationPool } = fetchGAWState(state);
  if (confirmationPool) {
    return confirmationPool;
  }
  return [];
};

export const selectPaymentInfo = (state) => {
  const { paymentInformation } = confirmationMap(state);
  if (paymentInformation && paymentInformation.payment) {
    return paymentInformation.payment;
  }
  return [];
};

export const selectStartDate = (state) => {
  const { gaStartDate } = confirmationMap(state);
  if (gaStartDate) {
    return gaStartDate;
  }
  return '';
};

export const selectEndDate = (state) => {
  const { gaEndDate } = confirmationMap(state);
  return gaEndDate;
};

export const selectStatus = (state) => {
  const { status } = confirmationMap(state);
  return status;
};

export const selectGrantAgreementAmount = (state) => {
  const { grantAgreementAmount } = confirmationMap(state);
  return grantAgreementAmount;
};

export const selectNoOfPayments = (state) => {
  const { noOfPayments } = confirmationMap(state);
  return noOfPayments;
};

export const selectInvestmentType = (state) => {
  const { investmentType } = confirmationMap(state);
  return investmentType;
};

export const selectGrantAgreementEnteredDate = (state) => {
  const { grantAgreementEnteredDate } = confirmationMap(state);
  return grantAgreementEnteredDate;
};

export const selectPermissionToPublish = (state) => {
  const { permissionToPublish } = fetchGAWState(state);
  return permissionToPublish;
};

export const confirmationPageDerivedStates = createStructuredSelector({
  accountId: selectAccountID,
  purpose: selectGrantPurpose,
  recognition: selectGrantRecognitions,
  contact: selectGranteeOrg,
  grantAgreementId: selectGrantAgreementId,
  investments: selectConfirmationPools,
  payments: selectPaymentInfo,
  startDate: selectStartDate,
  endDate: selectEndDate,
  status: selectStatus,
  grantAgreementAmount: selectGrantAgreementAmount,
  noOfPayments: selectNoOfPayments,
  investmentType: selectInvestmentType,
  grantAgreementEnteredDate: selectGrantAgreementEnteredDate,
  permissionToPublish: selectPermissionToPublish,
  advisors: selectAdvisors,
  codeValueMappingData: mapData,
});
